import React, { Component } from 'react';
import { Box, Typography } from '@mui/material';
import IbssSvgIcon from '../../Icons/SvgIcon/IbssSvgIcon';
import { IbssComponent } from '../../Core/BaseComponent/IbssComponent';

class IbssPageHeader extends IbssComponent<IProps, IState>
{
    public render(): JSX.Element
    {
        const { title, description, icon } = this.props;
        return (
            <Box mb={1}>
                <Box display="flex" alignItems="center" gap={icon ? 2 : 0}>
                    {
                        icon && <IbssSvgIcon fontSize="large">{this.props.icon}</IbssSvgIcon>
                    }
                    <Box>
                        {
                            title && <Typography variant="h5" sx={{ fontSize: '1.625rem' }}>{title}</Typography>
                        }
                    </Box>
                </Box>
                {
                    description &&
                    <Box pt={1}>
                        <Typography variant="body2" sx={{ color: 'var(--ui-text)' }}>{this.props.description}</Typography>
                    </Box>
                }
            </Box>
        )
    }
};

export interface IProps
{
    title: string;
    description?: string;
    icon?: JSX.Element;
}

export interface IState
{
}

export default IbssPageHeader;